"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferStepBasicInfoEdit = void 0;
var OfferStepBasicInfoEdit_1 = require("./OfferStepBasicInfoEdit");
Object.defineProperty(exports, "OfferStepBasicInfoEdit", { enumerable: true, get: function () { return OfferStepBasicInfoEdit_1.OfferStepBasicInfoEdit; } });
